var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px",
      "background-color": "white",
      "position": "relative"
    }
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h3', [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.historyOrderLbl))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate("orders of clients")) + ": " + _vm._s(_vm.$Jed.firstUpperTranslate("row") + ' ' + _vm.currentRow + ' ' + _vm.$Jed.translate("of") + ' ' + _vm.maxRows))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('grid', {
    attrs: {
      "columns": _vm.gridProdAttributesCfg.columns,
      "source": _vm.arrayToTable,
      "options": _vm.options,
      "others": _vm.others,
      "lang": _vm.$root.token.idLingua,
      "name": _vm.gridProdAttributesCfg.title,
      "rowClick": _vm.rowClicked
    },
    on: {
      "update:source": function($event) {
        _vm.arrayToTable = $event
      }
    }
  })], 1)])])])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v(" ")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de6b1358","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/OrdersArchive.vue
// module id = 1723
// module chunks = 1